module.exports = __webpack_public_path__ + "static/index/img/baikal-709.5c8cf0ac.jpg";